import React from 'react';
import ReactDOM from 'react-dom/client';
import App from 'src/App';
import reportWebVitals from 'src/reportWebVitals';
import { GlobalStyles } from 'src/GlobalStyles';
import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import 'antd/dist/antd';
import { store } from 'src/redux/store';
import ptBR from 'antd/locale/pt_BR';
import Subscriptions from 'src/components/rendered/Subscriptions';
import AuthProvider from 'src/AuthProvider';
import { ErrorBoundary } from 'react-error-boundary';
import GlobalErrorFallback from 'src/components/GlobalErrorFallback';

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<Provider store={store}>
		<ErrorBoundary FallbackComponent={GlobalErrorFallback}>
			<ConfigProvider locale={ptBR}>
				<BrowserRouter>
					<AuthProvider>
						<Subscriptions />
						<App />
						<ToastContainer position="bottom-right" />
					</AuthProvider>
				</BrowserRouter>
			</ConfigProvider>
			<GlobalStyles />
		</ErrorBoundary>
	</Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
